import { delay, fork, put, select, take, takeEvery } from 'redux-saga/effects';

import { SubmitStakePayload } from './staking/types';
import type { SagaIterator } from '@redux-saga/types';

import { DEFAULT_TRANSITION_DURATION } from 'app/constants/animation';
import { switchActiveKey } from 'app/modules/Layout/Sidebar/actions';
import { Tab } from 'app/modules/Layout/Sidebar/constants';
import { selectActiveTab } from 'app/modules/Layout/Sidebar/selectors';

import { ADD_BIG_STAKE, AddBigStake } from '../actions/bigStakes';
import {
  PROCESS_ENTRY, ProcessEntry,
  processEntryFailure,
  processEntrySuccess,
} from '../actions/oneClickBet';
import {
  SUBMIT_STAKE_FAILURE, SUBMIT_STAKE_SUCCESS, SubmitStakeFailure,
  SubmitStakeSuccess,
} from '../actions/submission';
import { DISPLAY_RESULTS_TIMEOUT, SubmitStakeType } from '../constants';
import { selectOneClickBetAmount } from '../selectors/oneClickBet';
import { PresetWithDisplayType } from '../types/oneClickBet';
import { submitStake } from './staking';

// ---

export default function* oneClickBetProcessor(): SagaIterator {
  yield takeEvery(PROCESS_ENTRY, function* (action: ProcessEntry) {
    const { entity } = action.payload.bet;

    if (!entity.price) {
      console.error('oneClickBetProcessor -> `entity.price` not a number');
      return;
    }

    const amount: PresetWithDisplayType = yield select(selectOneClickBetAmount);
    const activeTab: Tab = yield select(selectActiveTab);

    if (activeTab === Tab.MY_STAKES) {
      yield put(switchActiveKey(Tab.BET_SLIP));
    }

    const payload: SubmitStakePayload = {
      type: SubmitStakeType.SINGLE,
      bets: [{
        id: entity.id,
        matchId: entity.matchId,
        price: entity.price,
      }],
      amount: amount.value,
    };

    yield fork(processComplete);
    yield fork(submitStake, payload);
  });
}

// ---

type ProcessCompleteActions =
  | SubmitStakeSuccess
  | SubmitStakeFailure
  | AddBigStake;

function* processComplete() {
  const action: ProcessCompleteActions = yield take([
    SUBMIT_STAKE_SUCCESS,
    SUBMIT_STAKE_FAILURE,
    ADD_BIG_STAKE,
  ]);

  if (action.type !== ADD_BIG_STAKE) {
    // let user to see the results
    yield delay(Math.max(DISPLAY_RESULTS_TIMEOUT, (DEFAULT_TRANSITION_DURATION + 10)));
  }

  switch (action.type) {
    case ADD_BIG_STAKE:
    case SUBMIT_STAKE_SUCCESS:
      yield put(processEntrySuccess());
      break;

    case SUBMIT_STAKE_FAILURE:
      yield put(processEntryFailure());
      break;
  }
}
